export default __webpack_public_path__ + "static/media/speakerHolder.616feaa7.png";